










import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component({ name: 'Progress' })
export default class Progress extends Vue {
  @Getter('survey/getCurrentProductSurveySectionCount')
  totalSurveyProgressItemsCount?: number

  @Getter('survey/getNextSurveySectionNumber')
  sectionNumber?: number

  @Prop({})
  totalPropsProgressItemsCount?: number

  @Prop({ default: true })
  showTitle?: boolean

  @Prop({ default: true })
  showPercentInside?: boolean

  @Prop({})
  processedPropsItemsCount?: number

  @Prop({ default: false })
  percentage?: boolean

  @Prop({ default: '9px' })
  height?: string

  get totalProgressItemsCount () : number {
    if (this.totalPropsProgressItemsCount) {
      return this.totalPropsProgressItemsCount
    }

    if (this.totalSurveyProgressItemsCount) {
      return this.totalSurveyProgressItemsCount
    }

    return 0
  }

  get processedItemsCount () : number {
    if (typeof this.processedPropsItemsCount !== 'undefined') {
      return this.processedPropsItemsCount
    }

    if (this.sectionNumber) {
      return this.sectionNumber - 1
    }

    return 0
  }

  get processedPercent () : number {
    return (this.processedItemsCount && this.totalProgressItemsCount)
      ? Math.ceil(this.processedItemsCount / this.totalProgressItemsCount * 100)
      : 0
  }

  get formattedProcessedItemsCount () : string|0 {
    return this.percentage && this.processedPercent ? this.processedPercent.toFixed(0) : 0
  }
}
